import React from 'react';
import styled from 'styled-components';
import { BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

const NotificationButton = styled.button`
  position: relative;
  background: none;
  border: none;
  color: ${props => props.theme.colors.text.primary};
  cursor: pointer;
  padding: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.md};
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.theme.colors.surface};
    transform: translateY(-1px);
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

const NotificationBell = () => {
  const { isAuthenticated } = useAuth();
  
  // For now, just show a simple notification bell
  const handleClick = () => {
    // TODO: Implement notification functionality
    console.log('Notification bell clicked');
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <NotificationButton onClick={handleClick}>
      <BellIcon />
    </NotificationButton>
  );
};

export default NotificationBell; 